import { render, staticRenderFns } from "./ParseFileDialog.vue?vue&type=template&id=63655793&scoped=true&"
import script from "./ParseFileDialog.vue?vue&type=script&lang=js&"
export * from "./ParseFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63655793",
  null
  
)

export default component.exports